import {
    Breadcrumb,
    Button,
    Col,
    Drawer,
    Dropdown,
    Empty,
    Form, FormInstance,
    Input,
    Menu,
    Modal,
    Pagination,
    Popconfirm,
    Radio,
    Row,
    Select,
    Space,
    Table,
    Tag,
    TimePicker,
    notification
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { NavLink, RouteComponentProps } from "react-router-dom";
import { RootStoreModel } from "../../../redux/reducers";
import {
    BasicStateForListModel
} from "../../models";

import {
    AndroidFilled,
    AppleFilled, DeleteOutlined,
    DownOutlined,
    PlusOutlined,
    createFromIconfontCN
} from '@ant-design/icons';
import dayjs from 'dayjs';
import {
    addMacTemplate,
    copyMacTemplates,
    deleteMacTemplate,
    getMacTemplate,
    getMacTemplateList
} from "../../../axios/api.device";

import { MacContentAppRestriction } from "./mac.contentAppRestriction";
import "./mac.scss";

import { Translation } from "react-i18next";


const {Column} =Table
const { SubMenu } = Menu;
const { Item } = Form;
const MyIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2670925_pf3sykyocl.js', // 在 iconfont.cn 上生成
});
interface stateModel extends BasicStateForListModel {
    name: string,
    current: string,
    selectTemplate: string,
    isShowTable: boolean,
    search: string,
    isShowAddForm: boolean,
    selectRow: any,
    showRightBox: boolean
    selectDevices: any[],
    currentName: string,
    templateTabs: any[],
    dropdownVisible: any[],
    isModify: boolean,
    templateItemsStatus: any,
    templateItemsMap: any,
    configFileType: string,
    isSelectdItem: boolean,
    templateSelectItemsMap: any,
    platform:string,
    brand:string
}
interface propsModel extends RouteComponentProps<any, any, any> {
    tokenSuccess: boolean
}
const mapStatetoProps = (state: RootStoreModel) => ({
    tokenSuccess: state.userState.tokenSuccess
});

class TemplateMacIndex extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            name: "TemplateMacIndex",
            current: "Applications",
            currentName: "",
            selectTemplate: "",
            isShowTable: true,
            pageIndex: 1,
            pageSize: 10,
            totalCount: 0,
            search: "",
            loading: false,
            data: [],
            columns: [],
            isShowAddForm: false,
            selectRow: {},
            showRightBox: false,
            selectDevices: [],
            templateTabs: [],
            dropdownVisible: [],
            isModify: false,
            isSelectdItem: false,
            platform: "",
            brand:"",
            templateItemsStatus: {
                App: false,
                MultiAppsMode: false,               
                WebFilter: false,
                CustomScript: false
            },
            templateItemsMap: {
                Applications: "App",
                MacAppRestriction: "MacAppRestriction",
                WebContent: "WebFilter",
                CustomScript: "CustomScript"
            },
            templateSelectItemsMap: {
                App: "Applications",
                MacAppRestriction: "MacAppRestriction",
                WebFilter: "WebContent",
                CustomScript: "CustomScript"
            },
            configFileType: "Default"
        }
    }
    Init() {
        this.getList();
        // this.getDeviceAll();
        // getTemplateTabs().then(c => {
        //     this.setState({ templateTabs: c })
        // });
        console.log("statessss",this.props.history.location.state);
        if (this.props.history.location.state && Object.keys(this.props.history.location.state).length > 0) {
            this.operationClick({key: 'edit'}, this.props.history.location.state);
        }
    }
    componentDidMount() {
        if (this.props.tokenSuccess) {
            this.Init();
        }

    }
    componentDidUpdate(prevProps: propsModel) {
        if (this.props.tokenSuccess !== prevProps.tokenSuccess) {
            this.Init();
        }
    }

    deviceHandleChange(value: any[]) {
        this.setState({ selectDevices: value });
    }
    getList(pageIndex = this.state.pageIndex,
        pageSize = this.state.pageSize) {
        var temArg = {
            pageIndex: pageIndex,
            pageSize: pageSize,
            search: this.state.search,
            category: "Mac"
        }
        getMacTemplateList(temArg).then(
            (res) => {
                this.setState({
                    data: res.dataList,
                    pageSize: res.pageSize,
                    pageIndex: res.pageIndex,
                    loading: false,
                    totalCount: res.totalCount,
                    dropdownVisible: [],
                });
                res.dataList.forEach((item: any) => {
                    this.state.dropdownVisible.push({key: item.id, value: false});
                });
            })
    }
    templateNameUpdate = (e: any) => {
        console.log(e);
        var sele = {
            name: e.target.value,
            id: this.state.selectRow.id,
            platform: this.state.selectRow.platform,
            brand: this.state.selectRow.brand,
            status: this.state.selectRow.status,
            category: "Mac"
        }
        this.setState({ selectRow: sele })
    }

    handleMenuClick = (e: any) => {
        var currname = "";
        switch (e.key) {
            case "Applications":
                currname = "企业应用";
                break;
        }
        this.setState({ current: e.key, currentName: currname });
    };
    onSearch = () => {
        this.getList();

    }

    subTemplateNameClick() {
        var sele = {
            name: this.state.selectRow.name,
            id: this.state.selectRow.id,
            platform: this.state.selectRow.platform,
            brand :this.state.selectRow.brand,
            status: this.state.selectRow.status,
            category: "Mac"
        }
        addMacTemplate(sele).then(c => {
            this.getList();
            this.setState({ showRightBox: false })
        })
    }
    addTemplateClick = () => {
        this.setState({ loading: true });
        this.formRef.current?.validateFields().then(
            (res) => {
                res.platform = "macOS";
                res.status = "Active";
                res.isCustomized = false;
                res.executionRules = [];
                res.type = "Default";
                res.category = "Mac";
                console.log("addTemplate",res)
                addMacTemplate(res).then(
                    () => {
                        this.getList();
                        this.setState({ isShowAddForm: false });
                        this.formRef.current?.resetFields();
                        notification.success({message: <Translation>{t => {return `${this.state.isModify ? t("编辑应用限制成功") : t("添加应用限制成功")}`}}</Translation>});
                    },
                    () => { notification.error({message: <Translation>{t => {return `${this.state.isModify ? t("编辑应用限制失败") : t("添加应用限制失败")}`}}</Translation>}) }
                ).finally(
                    () => { 
                        this.setState({
                            loading: false, 
                            isModify: false, 
                            configFileType: "Default"
                        }) 
                    }
                )
            },
            () => { this.setState({loading: false}) }
        )
    }
    operationClick = (e: any, row: any) => {
        if (!e.key) {
            return
        }
        switch (e.key) {
            case "edit":
                var obj = {current: "Applications", name: "限制规则"};
                this.formRef.current?.setFieldsValue(row);
                this.setState({ 
                    isShowTable: false, 
                    currentName: obj.name, 
                    current: obj.current,
                    selectRow: row
                });
                this.getSelectedTemplate(row.id);
                this.getList();
                break;
            case "delete":
                deleteMacTemplate(row.id).then(
                    () => {
                        notification.success({ message: <Translation>{t => {return t("删除成功")}}</Translation> });
                        this.getList();
                    }, 
                    () => { notification.error({ message: <Translation>{t => {return t("删除失败")}}</Translation> }) }
                )
                break;
            case "copy":
                copyMacTemplates({id: row.id, name: `${row.name}_拷贝`}).then(
                    () => {
                        notification.success({ message: <Translation>{t => {return t("拷贝成功")}}</Translation> });
                        this.getList();
                    }, 
                    () => { notification.error({ message: <Translation>{t => {return t("拷贝失败")}}</Translation> }) }
                )
                break;
            case "modify":
                getMacTemplate(row.id).then(
                    res => {
                        this.formRef.current?.setFieldsValue(row);
                        var worshipDays: any[] = [];
                        var dayList = res.executionRules ? res.executionRules.map((item: any) => {
                            worshipDays.push(item.worshipDay);
                            item["times"] = item.durations.map((duration: any) => {
                                var starArr = duration.startTime.split(":");
                                var endArr = duration.endTime.split(":");
                                var startTime = dayjs().hour(parseInt(starArr[0])).minute(parseInt(starArr[1]));
                                var endTime = dayjs().hour(parseInt(endArr[0])).minute(parseInt(endArr[1]));
                                return [startTime, endTime];
                            });
                            return item;
                        }) : [];
                        this.setState({
                            isModify: true, 
                            isShowAddForm: true, 
                            configFileType: res.type,
                            platform:row.platform
                        });
                    },
                    () => {
                        notification.error({message: <Translation>{t => {return t("获取应用限制失败")}}</Translation>})
                    }
                )
                break;
            case "devices":
                this.props.history.push({
                    pathname: `/home/mac/appRestriction/devices/${row.id}`, 
                    state: row
                });
                break;
        
            default:
                break;
        }
    }
    onClose = () => {
        this.setState({
            showRightBox: false,
        });
    };
    getTemplateTab = () => {
        var tab = this.state.templateTabs.find(c => {
            return c.tabKey === this.state.current;
        })
        return tab;

    }

    getSelectedTemplate = (templateId: string) => {
        this.setState({ isSelectdItem: false });
        getMacTemplate(templateId).then(
            (res) => {
                const {selectdItemList} = res;
                const {templateSelectItemsMap} = this.state;
                const items: any = {};
                if (selectdItemList.length > 0) {
                    var current = templateSelectItemsMap[selectdItemList[0]]
                    this.setState({ isSelectdItem: true,current: current });
                    selectdItemList.forEach((item: any) => {
                        items[item] = true;
                    })
                }
                this.setState({templateItemsStatus: items});
                
            },
            () => { notification.error({message: <Translation>{t => {return t("获取模板数据失败")}}</Translation>}) }
        )
    }

    updateTemplate = () => {
        this.getSelectedTemplate(this.state.selectRow.id);   
    }

    render() {
        const { 
            name, current, selectTemplate, isShowTable, templateItemsStatus, 
            templateItemsMap, data, pageIndex, pageSize, totalCount, search, 
            loading, isShowAddForm, selectRow, showRightBox, 
            currentName, dropdownVisible, isModify, isSelectdItem
        } = this.state;
        return (
            (<Translation>{t => {
                    return (
                        (<div>
                            <div className="breadcrumbTop py-2">
                                <Breadcrumb>
                                   
                                    <Breadcrumb.Item>{t("Mac端管")}</Breadcrumb.Item>
                                    <Breadcrumb.Item>  
                                        <a onClick={() => {
                                            this.setState({ 
                                                isShowTable: true, 
                                                currentName: "", 
                                                current: "",
                                                templateItemsStatus: {
                                                    App: false,
                                                    MacAppRestriction: false,
                                                    WebFilter: false,
                                                }, 
                                            });
                                            this.props.history.replace("/home/mac/appRestriction/index");
                                        }}>{t("应用限制")}</a>
                                    </Breadcrumb.Item>
                                    {currentName?.trim() ? <Breadcrumb.Item>{t(currentName)}</Breadcrumb.Item> : null}
                                </Breadcrumb>
                                {!currentName && (
                                    <Row style={{padding: "32px 0 11px 0"}}>
                                        <Space>
                                            <img src="/images/profileIcon.svg" alt="" />
                                            <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("应用限制")}</span>
                                        </Space>
                                    </Row>
                                )}
                            </div>
                            <Row style={{ width: "100%" }}>
                                {!isShowTable && (
                                    <div className="borderBox">
                                        <Row style={{height: "36px", borderBottom: "1px solid #F1F1F1"}}>
                                            <Col span={20}>
                                                <NavLink style={{marginLeft: "16px"}} to={{
                                                    pathname: `/home/mac/appRestriction/devices/${selectRow.id}`, 
                                                    state: selectRow, 
                                                }}>
                                                    <img src="../../images/App.png" style={{marginTop: "-3px"}} alt="" />
                                                    <span>{t("关联设备")}</span>
                                                </NavLink>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={20}>
                                                <MacContentAppRestriction templateId={selectRow.id} platform={selectRow.platform} updateTemplate={this.updateTemplate}></MacContentAppRestriction>
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                                {isShowTable && (
                                    <>
                                        <div className="borderBox">
                                            <Row  className="mb-3">
                                                <Col > 
                                                {t("应用限制标题")}:
                                                <Input placeholder="" value={search}
                                                style={{ width: "200px", marginLeft: 10 }}
                                                    onChange={(e) => this.setState({ search: e.target.value })} /></Col>
                                                <Col offset={1}>
                                                    <Button type="primary" onClick={() => { this.onSearch(); }}>
                                                        {t("查询")}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="borderBox">
                                            <Row>
                                                <Col className="ms-auto" style={{ marginBottom: 8 }}>  <Button type="primary"
                                                    onClick={() => { this.setState({ isShowAddForm: true }) }}><PlusOutlined />{t("添加")} {t("应用限制")}</Button></Col>
                                            </Row>
                                            <Row  >
                                                <Col span={24}>
                                                    <Table 
                                                        size="middle" 
                                                        dataSource={data} 
                                                        rowKey={recored => recored.id} 
                                                        style={{ width: "100%", minHeight: 300 }} 
                                                        pagination={false}
                                                        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                                    >
                                                        <Column
                                                            title={t("应用限制标题")}
                                                            key="name"
                                                            dataIndex="name"
                                                        ></Column>
                                                        <Column
                                                            title={t("平台")}
                                                            key="platform"
                                                            dataIndex="platform"
                                                            render={(v: any) =>{
                                                                return (
                                                                <div >
                                                                {v==="Android"&&(
                                                                    <span>< AndroidFilled style={{color:"#999999",fontSize:20}}/>&nbsp;&nbsp;Android</span>
                                                                )}
                                                                {v==="IOS"&&(
                                                                    <span><AppleFilled style={{color:"#999999",fontSize:20}}/>&nbsp;&nbsp;iOS</span>
                                                                )}
                                                                {v==="macOS"&&(
                                                                    <span><img src="/images/macLogo.png" alt="" />&nbsp;&nbsp;macOS</span>
                                                                )}
                                                                </div>)
                                                                }}
                                                        ></Column>
                                                        {/* <Column title="创建人" key="model" dataIndex="model"></Column> */}

                                                        <Column
                                                            title={t("创建时间")}
                                                            key="createTime"
                                                            dataIndex="createTime"
                                                        ></Column>
                                                        <Column
                                                            title={t("最近修改时间")}
                                                            key="updateTime"
                                                            dataIndex="updateTime"
                                                        ></Column>
                                                        <Column
                                                            title={t("关联设备")}
                                                            key="deviceCount"
                                                            dataIndex="deviceCount"
                                                            align="center"
                                                            render={(v, row: any, index) => {
                                                                return (
                                                                    <NavLink to={{ pathname: `/home/mac/appRestriction/devices/${row.id}`, state: row }} >{v}</NavLink>
                                                                )
                                                            }}
                                                        ></Column>
                                                        <Column
                                                            title={t("操作")}
                                                            key="id"
                                                            dataIndex="id"
                                                            align="center"
                                                            render={(v, raw, index) => {
                                                                return (
                                                                    <Dropdown
                                                                        open={dropdownVisible.length > 0 && dropdownVisible[index]['value']}
                                                                        onOpenChange={(visible) => {
                                                                            const tempList: any[] = [];
                                                                            dropdownVisible.forEach((item) => {
                                                                                if (item.key === v) {
                                                                                    item['value'] = visible;
                                                                                }
                                                                                tempList.push(item);
                                                                            })
                                                                            this.setState({dropdownVisible: tempList});
                                                                        }}
                                                                        // trigger={['click']}
                                                                        dropdownRender={() => (
                                                                            <Menu onClick={(res) => this.operationClick(res, raw)}>
                                                                                <Menu.Item key='edit'>{t("编辑明细")}</Menu.Item>
                                                                                <Menu.Item key='modify'>{t("基本信息")}</Menu.Item>
                                                                                <Menu.Item key='devices'>{t("关联设备")}</Menu.Item>
                                                                                <Popconfirm title={"确认删除?"} onConfirm={() => this.operationClick({key: 'delete'}, raw)}>
                                                                                    <Menu.Item key='delete' className="custom-menu-item">{t("删除")}</Menu.Item>
                                                                                </Popconfirm>
                                                                                <Menu.Item key='copy'>{t("拷贝")}</Menu.Item>
                                                                            </Menu>
                                                                        )}>
                                                                        <a>{t("更多")}<DownOutlined /></a>
                                                                    </Dropdown>
                                                                )
                                                            }}></Column>
                                                    </Table>
                                                    <Pagination
                                                        style={{ textAlign: "right", marginTop: "20px" }}
                                                        pageSize={pageSize}
                                                        current={pageIndex}
                                                        total={totalCount}
                                                        showTotal={(total, range) =>
                                                            `${range[0]}-${range[1]} / ${total} ${t("条")}`
                                                        }
                                                        onChange={(page, pageSize) => {
                                                            this.getList(page, pageSize);
                                                        }}
                                                        onShowSizeChange={(current, size) => this.getList(current, size)}
                                                    ></Pagination>
                                                </Col>
                                            </Row>
                                            <Modal
                                                confirmLoading={loading}
                                                maskClosable={false}
                                                open={isShowAddForm}
                                                destroyOnClose={true}
                                                title={`${isModify ? "" : t("添加")} ${t("应用限制")}`}
                                                forceRender={true}
                                                width={"650px"}
                                                onOk={() => { this.addTemplateClick() }}
                                                onCancel={() => {
                                                    this.setState({ 
                                                        isShowAddForm: false,
                                                        isModify: false, 
                                                        loading: false,
                                                        configFileType: "Default"
                                                    });
                                                    this.formRef.current?.resetFields();
                                                }}
                                                okText={t("确认")}
                                                cancelText={t("取消")}
                                            >
                                                <Form
                                                    // labelCol={{ span: 6 }}
                                                    ref={this.formRef}
                                                    layout="vertical"
                                                    initialValues={{ name: ""}}
                                                >
                                                    <Item label="ID" name="id" hidden>
                                                        <Input></Input>
                                                    </Item>
                                                    <Item label={t("应用限制标题")} name="name" rules={[{ required: true }]}>
                                                        <Input></Input>
                                                    </Item>
                                                </Form>
                                            </Modal>
                                        </div>
                                    </>
                                )}
                            </Row>
                            <Drawer
                                title="编辑应用限制"
                                placement="right"
                                closable={true}
                                onClose={this.onClose}
                                open={showRightBox}
                                footer={
                                    <div
                                        style={{
                                            textAlign: 'right',
                                        }}
                                    >
                                        <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                                            取消
                                        </Button>
                                        <Button onClick={() => { this.subTemplateNameClick() }} type="primary">
                                            提交
                                        </Button>
                                    </div>
                                }
                            >
                                <Row>
                                    <Col span={6}>标题</Col>
                                </Row>
                                <Row>
                                    <Col span={24}><Input value={selectRow?.name} onChange={this.templateNameUpdate}></Input></Col>
                                </Row>

                            </Drawer>
                        </div>)
                    );
                }}</Translation>)
        );
    }
}
export default connect(mapStatetoProps, {})(TemplateMacIndex);